<template>
  <div class="format-change-wrapper">
    <h6 class="format-change-header flex items-center">
      HR 推荐模板样式
      <img
        class="vip"
        src="https://files.wondercv.com/pc-cvs/vip-icon.png"
        alt=""
      />
    </h6>
    <div class="template-style-list">
      <div
        v-for="(item, index) in tempStyleList"
        :key="index"
        class="template-img-container flex items-start"
        :class="{
          active: cvDetail.format_info.template_type === item.imgSrc,
        }"
      >
        <img
          class="template-style-item"
          :src="item.imgSrc"
          alt=""
          @click="clickTemplateItem(item)"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { debounce } from '@/assets/js/util';
import recommendTemplateStyle from '@/assets/json/recommend-template-style.json';
import { styleMixin } from '@/assets/js/mixins';
export default {
  name: 'ResumeFormatChange',
  mixins: [styleMixin],
  data() {
    return {
      tempStyleList: recommendTemplateStyle.editor,
    };
  },
  computed: {
    ...mapState('editor', ['cvDetail', 'profile']),
  },
  methods: {
    clickTemplateItem: debounce(function (item) {
      const { imgSrc, show_attr_name, ...rest } = item;
      this.selectInfo(show_attr_name);
      this.setFormatInfo(rest);
    }, 300),
    //更改format_info
    setFormatInfo: debounce(function (options) {
      //当前模块要有 key，value
      let cvDetail = JSON.parse(JSON.stringify(this.cvDetail));
      //同步数据
      Object.keys(options).forEach((key) => {
        cvDetail.format_info[key] = options[key];
        if (key === 'line_spacing') {
          //保存行距
          this.$store.commit('editor/setOldLineHeight', options[key]);
        }
      });
      this.$store.commit('editor/setCvDetail', cvDetail);

      //触发保存
      this.submit();
    }, 300),
    // 切换是否显示信息名称
    async selectInfo(value) {
      this.profile.show_attr_name = value;
      try {
        //检测是否有profile数据
        if (this.profile.id && typeof this.profile.id === 'number') {
          let res = await this.$store.dispatch('editor/updateProfileData', { payload: this.profile });
          if (res.code === 1000) {
          } else {
            this.$message.success(res.message);
          }
        }
      } catch (error) {}
    },
    // 保存
    async submit() {
      let { kind } = this.cvDetail.basic_info;
      console.log(kind, 'kind');
      if (kind === 'template' || kind === 'sample') return;
      try {
        const res = await this.$store.dispatch('editor/updateCvDetail', {
          operation_type: 'update_format_info',
          format_info: this.cvDetail.format_info,
          skipCheck: true,
        });
        if (res.code === 1000) {
          // this.$message.success('保存成功');
        } else {
          this.$message.success(res.message);
        }
      } catch (error) {
        this.$message.success('修改失败');
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/css/variable.scss';
.format-change-wrapper {
  width: 574px;
  padding-left: 24px;
  padding-right: 24px;
  box-sizing: border-box;
  height: 100%;
  overflow: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  .format-change-header {
    color: $text-color;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 16px;
    width: fit-content;
    img {
      width: 28px;
      margin-left: 6px;
    }
  }
  .template-style-list {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 32px;
    .template-img-container {
      display: flex;
      align-items: flex-start;
      width: 167px;
      height: 234px;
      overflow: hidden;
      cursor: pointer;
      border-radius: 6px;
      img {
        width: 100%;
        object-fit: cover;
        vertical-align: top;
      }
    }
    // .template-style-item {
    //   cursor: pointer;

    //   border-radius: 6px;
    //   // &.active,
    //   // &:hover {
    //   //   // border-color: #4183ff;
    //   // }
    // }
  }
}
</style>
